import { apiInitialState } from "../../../utils/apiStateUtils";
import { fetchFormConfigurations } from "../../inputFormConfigurations";

export default {
  surveyListApi: apiInitialState(),
  surveyList: null,
  suveyTableSearch: fetchFormConfigurations(["tableSearch"]),
  projectDetailsApi: apiInitialState(),
};
